'use client';

import * as React from 'react';
import { useState } from 'react';
import { Avatar, Box, Divider, List, ListItemButton, ListItemText, Skeleton, Stack, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { PlusCircle as PlusCircleIcon } from '@phosphor-icons/react';

import type { Community } from '@/types/v2/community';

export interface CommunitiesPopoverProps {
  anchorEl: null | Element;
  onChange?: (community: Community) => void;
  onClose?: () => void;
  open?: boolean;
  communities: Community[];
  community: Community | null;
  isLoading: boolean;
  onAddCommunity: () => void;
}

export function CommunitiesPopover({
  anchorEl,
  onChange,
  onClose,
  open = false,
  communities,
  community: selectedCommunity,
  isLoading,
  onAddCommunity,
}: CommunitiesPopoverProps): React.JSX.Element {
  const [searchTerm, setSearchTerm] = useState('');
  console.log('communities popover', communities);

  const filteredCommunities = communities.filter((community) =>
    community.name.toLowerCase().includes(searchTerm.toLowerCase()) && selectedCommunity
      ? community.name !== selectedCommunity.name
      : true
  );

  const handleSetCommunity = React.useCallback(
    (community: Community) => {
      onChange?.(community);
    },
    [onChange]
  );

  return (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
      onClose={onClose}
      open={open}
      slotProps={{ paper: { sx: { minWidth: '250px', maxWidth: '350px' } } }}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
    >
      {isLoading ? (
        <MenuItem>
          <Skeleton sx={{ fontSize: '1rem' }} variant="text" />
        </MenuItem>
      ) : filteredCommunities.length === 0 ? (
        <List sx={{ width: 300, p: 2 }}>
          <ListItemText primary="No additional communities found" secondary="Add a community to get started" />
        </List>
      ) : (
        <List sx={{ width: 300 }}>
          {filteredCommunities.map((community: Community) => (
            <ListItemButton
              key={community.id}
              onClick={() => {
                handleSetCommunity(community);
              }}
              sx={{
                p: 2,
              }}
            >
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2 }}>
                <Avatar sx={{ width: 40, height: 40 }} variant="square">
                  {community.name
                    .split(' ')
                    .map((word) => word[0])
                    .join('')}
                </Avatar>
                <Stack>
                  <ListItemText primary={community.name} />
                  <ListItemText secondary={community.address} />
                </Stack>{' '}
              </Box>
            </ListItemButton>
          ))}
        </List>
      )}
      <Divider sx={{ m: 1 }} />
      <Button
        color="secondary"
        onClick={onAddCommunity}
        startIcon={<PlusCircleIcon />}
        sx={{ m: 1 }}
        variant="outlined"
      >
        Add Community
      </Button>
    </Menu>
  );
}
